/** Shared orbit ring math (JDI ↔ JDL must stay in sync). */

export const MAX_CARD_WIDTH = 200;
export const MIN_CARD_WIDTH = 150;
export const CARD_ASPECT = 360 / 228;
export const CARD_GAP = 52;
export const MIN_ORBIT_RADIUS = 480;
export const MAX_RADIUS = 520;

export type OrbitLayout = {
  radius: number;
  cardWidth: number;
  cardHeight: number;
};

export function orbitLayout(count: number): OrbitLayout {
  if (count <= 1) {
    return {
      radius: 0,
      cardWidth: MAX_CARD_WIDTH,
      cardHeight: Math.round(MAX_CARD_WIDTH * CARD_ASPECT),
    };
  }
  const halfStep = Math.PI / count;
  const sinHalf = Math.sin(halfStep);
  let cardWidth = MAX_CARD_WIDTH;
  let radius = Math.ceil((cardWidth + CARD_GAP) / (2 * sinHalf));
  radius = Math.max(radius, MIN_ORBIT_RADIUS);

  if (radius > MAX_RADIUS) {
    radius = MAX_RADIUS;
    const chord = 2 * radius * sinHalf;
    cardWidth = Math.floor(chord - CARD_GAP);
    if (cardWidth < MIN_CARD_WIDTH) {
      cardWidth = MIN_CARD_WIDTH;
      radius = Math.max(
        MIN_ORBIT_RADIUS,
        Math.ceil((cardWidth + CARD_GAP) / (2 * sinHalf)),
      );
    }
  }

  return {
    radius,
    cardWidth,
    cardHeight: Math.round(cardWidth * CARD_ASPECT),
  };
}

/** Reserve layout height before the code-split orbit hydrates (prevents footer CLS). */
export function orbitShellMinHeight(postCount: number): number {
  if (postCount <= 1) return 520;
  const { radius, cardHeight } = orbitLayout(postCount);
  const stageH = Math.max(440, cardHeight + 90);
  const chrome = 120;
  // 3D ring spills beyond the stage box; tuned to measured ~1280px desktop column.
  const ringVertical = Math.round(radius * 1.75 + cardHeight);
  return chrome + Math.max(stageH, ringVertical);
}
